export default __webpack_public_path__ + "static/media/logo.5397d12f.svg";